import { initialState, ServerSideRenderingState } from "@affinity/Store/AffinityServerSideRenderingState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";


const reducer = {
    "Affinity/ServerSideRendering/SecurityToken/Set": (
        draft: Draft<ServerSideRenderingState>,
        action: { value: string }
    ) => {
        draft.SecurityToken = action.value;
    }
}

export default createTypedReducerWithImmer(initialState, reducer);